
import request from "@/api/index";
/* 教育局端首页-接口 */
//参与情况概览/区
export function handleParticipation(params) {
    return request({
        url:'/dataservice/api/1/1323',
        method: "get",
        params,
    });
}
//课程资源建设分析模型/区
export function handleResourceBuild(params) {
    return request({
        url:'/dataservice/api/1/1329',
        method: "get",
        params,
    });
}
//时长分析模型/区/学段
export function handleDuration(params) {
    return request({
        url:'/dataservice/api/1/1330',
        method: "get",
        params,
    });
}
//各学校工作教师/学生参与率柱状图（教师前10)校
export function handleParticipatioRateTeacherTop(params) {
    return request({
        url:'/dataservice/api/1/1331',
        method: "get",
        params,
    });
}
//各学校工作教师/学生参与率柱状图（教师后10)校
export function handleParticipatioRateTeacherLow(params) {
    return request({
        url:'/dataservice/api/1/1332',
        method: "get",
        params,
    });
}
//各学校工作教师/学生参与率柱状图
export function handleParticipatioRateStudentTop(params) {
    return request({
        url:'/dataservice/api/1/1333',
        method: "get",
        params,
    });
}
//各学校工作教师/学生参与率柱状图（教师前10)校
export function handleParticipatioRateStudentLow(params) {
    return request({
        url:'/dataservice/api/1/1334',
        method: "get",
        params,
    });
}
//各机构开课数前十/校
export function handleOpenClassTop(params) {
    return request({
        url:'/dataservice/api/1/1335',
        method: "get",
        params,
    });
}
//各区遴选机构课程情况
export function handleSelectionAgency(params) {
    return request({
        url:'/dataservice/api/1/1418',
        method: "get",
        params,
    });
}
//工作开展情况
export function handleOpenWork(params) {
    return request({
        url:'/dataservice/api/1/1420',
        method: "get",
        params,
    });
}
//各类课程开班情况
export function handleClassOpen(params) {
    return request({
        url:'/dataservice/api/1/1831',
        method: "get",
        params,
    });
}
//师生出勤率情况
export function handleAttendancePer(params) {
    return request({
        url:'/dataservice/api/1/1834',
        method: "get",
        params,
    });
}
export function handleRosterStatistics(params) {
    return request({
        url:'/dataservice/api/1/1828',
        method: "get",
        params,
    });
}
//课后服务开展明细情况
export function handleStatistics(params) {
    return request({
        url:'/dataservice/api/1/1836',
        method: "get",
        params,
    });
}
//学校参与统计
export function handleSchoolJionStatistics(params) {
    return request({
        url:'/dataservice/api/1/1844',
        method: "get",
        params,
    });
}
//教师参与统计
export function handleTecharJionStatistics(params) {
    return request({
        url:'/dataservice/api/1/1848',
        method: "get",
        params,
    });
}
//学生参与统计
export function handleStudentJionStatistics(params) {
    return request({
        url:'/dataservice/api/1/1854',
        method: "get",
        params,
    });
}
//课程建设情况
export function handleCurriculumWord(params) {
    return request({
        url:'/dataservice/api/1/1827',
        method: "get",
        params,
    });
}




